import { render, staticRenderFns } from "./DashboardCarousels.vue?vue&type=template&id=5d8aa710&scoped=true&"
import script from "./DashboardCarousels.vue?vue&type=script&lang=js&"
export * from "./DashboardCarousels.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCarousels.vue?vue&type=style&index=0&id=5d8aa710&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8aa710",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VHover } from 'vuetify/lib/components/VHover';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCarousel,VCarouselItem,VCol,VFadeTransition,VHover,VRow})
